/**
 * This file is part of an epic that is currently on hold and is not being used in the application.
 * Please refer to the README.md file in the root of the PDFRenderer directory for more information.
 */
import { Styles } from "@react-pdf/renderer";

import { pixelsToPoints } from "./helpers";

/**
 * Color constants based on ./PerformYard/webserver/assets/sass/config/colors.scss
 * Unfortunately, react-pdf doesn't appear to support css variables, this is an
 * object to use in their place.
 */
export const COLORS = {
	primary: {
		5: "#3E90C1",
	},
	neutral: {
		0: "#FFFFFF",
		1: "#F5F5F5",
		2: "#E9EAEC",
		7: "#525861",
		9: "#1D1F23",
	},
	green: {
		1: "#E3F1E0",
		5: "#53A93F",
	},
	yellow: {
		1: "#FBF3D7",
		5: "#e3b505",
	},
	red: {
		1: "#FDE6E3",
		5: "#f1634f",
	},
};

/**
 * Determines how large to render scalable-styled components.
 * 1 === 100%, 0.8 === 80% etc.
 */
export const SCALE_MAP = {
	default: 1,
	small: 0.8,
	medium: 1.2,
	large: 1.4,
};

/**
 * Determines how much margin to apply to our pages.
 */
export const MARGIN_MAP = {
	none: {
		// we need to provide enough vertical space to prevent overlapping with the footer/header
		vertical: 36,
		horizontal: 0,
	},
	default: {
		vertical: 54,
		horizontal: 36,
	},
	"0.5": {
		vertical: 36,
		horizontal: 36,
	},
	1: {
		vertical: 72,
		horizontal: 72,
	},
	"1.5": { vertical: 108, horizontal: 108 },
	2: { vertical: 144, horizontal: 144 },
};

/**
 * Common styles that do not change. Does not include any "scalable" values.
 */
export const BASE_STATIC_STYLES: Styles = {
	page: {
		fontFamily: "Noto Sans",
		height: "100%",
		display: "flex",
		flexDirection: "column",
	},
	section: {
		marginBottom: pixelsToPoints(36),
	},
	reviewFormTitle: {
		fontWeight: "semibold",
		marginBottom: pixelsToPoints(24),
	},
	headerTitle: {
		fontWeight: "semibold",
		marginBottom: pixelsToPoints(4),
	},
	headerSubtitleText: {
		fontWeight: "normal",
		color: COLORS.neutral[7],
	},
	headerSubtitleDate: {
		fontWeight: "semibold",
		color: COLORS.neutral[7],
	},
	headerAdditionalInfoContainer: {
		display: "flex",
		flexDirection: "row",
		color: COLORS.neutral[7],
		marginBottom: pixelsToPoints(8),
	},
	headerAdditionalInfoLabel: {
		fontWeight: "semibold",
	},
	flexContainer: {
		display: "flex",
		flexDirection: "row",
	},
	headerSubTitle: {
		fontWeight: "normal",
	},
	questionText: {
		fontWeight: "semibold",
		marginBottom: pixelsToPoints(4),
		color: COLORS.neutral[9],
	},
	questionSubtext: {
		fontWeight: "normal",
		marginBottom: pixelsToPoints(20),
		color: COLORS.neutral[7],
	},
	answerText: {
		fontWeight: "normal",
		color: COLORS.neutral[9],
	},
};

export type BaseStyles = typeof BASE_STATIC_STYLES;
